<!--
 * @Author: zjw
 * @Date: 2021-05-26 10:02:31
 * @LastEditTime: 2023-04-02 19:29:55
 * @FilePath: \web-app\src\components\content\myTable.vue
 * @Environment: Vue + Element
 * @Description: 表格组件
-->
<template>
    <div class="my-table">
        <!-- 源数据    stripe  highlight-current-row 高亮不能取消-->
        <!-- row-click  双击取消之后点击不能高亮 -->
        <el-table
            style="width: 100%"
            :ref="flag"
            border
            fit
            tooltip-effect="dark"
            size="small"
            v-loading="loading"
            :row-class-name="tableRowClassName"
            element-loading-text="拼命加载中"
            :data="tableData"
            @selection-change="handleSelectionChange"
            @row-click="handleCurrentChange"
            @row-dblclick="handleRowdbClick"
            :row-key="getkey"
        >
            <!-- 是否多选框 -->
            <el-table-column
                type="selection"
                width="50"
                v-if="isSelection"
                :reserve-selection="true"
                align="center"
                :selectable="selectEnableChange"
            >
            </el-table-column>

            <!-- 序号 -->
            <el-table-column label="序号" align="center" width="80">
                <template slot-scope="scope">
                    <!-- 序号连续自增：(当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1 -->
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>

            <!-- 表格数据列     :formatter="th.formatter || undefined"    show-overflow-tooltip  -->
            <el-table-column
                align="center"
                show-overflow-tooltip
                v-for="(th, key) in tableHeader"
                :key="key"
                :prop="th.prop"
                :label="th.name"
                :fixed="th.fixed"
                :width="th.width"
                :resizable="false"
            >
                <!-- 用于区分主要内容、状态栏、操作栏 -->
                <template slot-scope="scope">
                    <!-- 状态栏 -->
                    <div v-if="th.isSwitch" class="column_wrap">
                        <el-button
                            size="mini"
                            align="center"
                            :type="scope.row.status ? 'danger' : 'primary'"
                            @click="switchStatus(scope.row)"
                            >{{ scope.row.status | formatStatus }}</el-button
                        >
                    </div>
                    <!-- 主要内容 v-html="formatText(scope.row, th.prop)" -->
                    <div v-else class="column_wrap">
                        <div @click="th.clickFun && th.clickFun(scope.row)">
                            <span v-if="!th.formatData">
                                <font class="text">{{ scope.row[th.prop] }}</font>
                            </span>
                            <span
                                v-else
                                v-html="
                                    formatter(scope.row[th.prop], th.formatData)
                                "
                            ></span>
                        </div>
                    </div>
                    <!-- 操作栏 -->
                    <div v-if="th.operation" class="column_wrap">
                        <el-button
                            :type="o.type ? o.type : 'text'"
                            :icon="o.icon ? o.icon : ''"
                            size="mini"
                            v-for="(o, key) in th.operation"
                            :key="key"
                            @click.stop="o.clickFun && o.clickFun(scope.row)"
                            >{{ o.name }}</el-button
                        >
                    </div>
                </template>
            </el-table-column>

            <!-- 操作栏 -->
            <slot name="table_after"></slot>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "myTable",
    data() {
        return {
            activeId: "",
        };
    },
    filters: {
        formatStatus(status) {
            let statusArray = ["已启用", "已禁用"];
            return statusArray[status];
        },
    },
    props: {
        flag: {
            type: String,
            default: "multipleTable",
        },
        // 源数据
        tableData: {
            type: Array,
            required: true,
            default: function () {
                return [];
            },
        },
        // 表格数据列
        tableHeader: {
            type: Array,
            required: true,
            default: function () {
                return [];
            },
        },
        /**
         * 分页参数
         * @param {*} currentPage  第几页
         * @param {*} pageSize  每页的数据
         */
        pageParams: {
            type: Object,
            default: function () {
                return {
                    currentPage: 1,
                    pageSize: 15,
                };
            },
        },
        // 是否加载
        loading: {
            type: Boolean,
            default: false,
        },
        // 是否多选
        isSelection: {
            type: Boolean,
            default: false,
        },
        //
        getkey: {
            type: Function,
            default: (val) => {
                return val.id;
            },
        },
        selectEnable: {
            //多选
            type: Function,
            default: function () {
                return true;
            },
        },
    },

    methods: {
        // formatText(row, column) {
        //     if (column == "docIntroduction") {
        //         if (row.docIntroduction.length > 12) {
        //             return row.docIntroduction.substring(0, 12) + "...";
        //         } else {
        //             return row.docIntroduction;
        //         }
        //     } else {
        //         return row[column];
        //     }
        // },
        formatter(val, fun) {
            if (typeof fun === "function") {
                return fun(val);
            } else return val;
        },
        //批量操作事件
        handleSelectionChange(val) {
            this.$emit("handleSelectionChange", val);
        },

        //单选事件
        handleCurrentChange(val, a) {
            this.$emit("handleCurrentChange", val);
            this.activeId = val.id;
        },

        switchStatus(e) {
            console.log(e);
        },

        // 选中背景颜色
        tableRowClassName({ row, rowIndex }) {
            if (row.id == this.activeId) {
                return "active-row";
            } else if (rowIndex % 2 != 0) {
                return "success-row";
            }
        },
        // 双击之后取消背景色
        handleRowdbClick(row) {
            this.activeId = "";
            // 有的时候会在父组件中手动调用该方法清高亮  此时row为空的不需要传递row
            if (row) {
                this.$emit("handleRowdbClick", row);
            }
        },
        selectEnableChange(row) {
            return this.selectEnable(row);
        },
    },
    mounted() {
        // 给table添加一个清除勾选的方法
        this.$bus.$on("clearSelection", () => {
            if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection();
            }
        });
        // table清除高亮
        this.$bus.$on("clearActive", () => {
            this.handleRowdbClick();
        });
    },
    beforeDestroy() {
        this.$bus.$off("clearSelection");
        this.$bus.$off("clearActive");
    },
};
</script>


<style lang="scss" scoped>
.status-button {
    width: 50px;
}
/deep/ .el-table .success-row {
    background: #fafafa;
}
/deep/ .el-table__header {
    height: 60px;
    font-size: 14px;
}
/deep/ .el-table .active-row {
    background: #ecf5ff !important;
}
/* hover效果 */
/deep/ .el-table tbody tr:hover > td {
    background-color: #ecf5ff;
}
::v-deep .el-button--text {
    color: #2d5ec5;
}
.text{
	display: block;
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>
